import { DEFAULT_LANG } from '../constants';

export function getLocalizedUrlPath(path: string, lang: string): string {
  return lang === DEFAULT_LANG ? path : `/${lang}${path}`;
}
